// frontend/src/services/logs.js
import api from './api';

export const getAuditLogs = async (params = {}) => {
  try {
    const response = await api.get('/logs/audit', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching audit logs:', error);
    throw error;
  }
};

export const getReactionLogs = async (params = {}) => {
  try {
    // Clean up params - convert empty strings to null
    const cleanedParams = { ...params };
    Object.keys(cleanedParams).forEach(key => {
      if (cleanedParams[key] === '') {
        cleanedParams[key] = null;
      }
    });
    
    const response = await api.get('/logs/reactions', { params: cleanedParams });
    return response.data;
  } catch (error) {
    console.error('Error fetching reaction logs:', error);
    throw error;
  }
};

export const getSystemEvents = async (params = {}) => {
  try {
    const response = await api.get('/logs/system-events', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching system events:', error);
    throw error;
  }
};

export const getReactionLog = async (logId) => {
  try {
    const response = await api.get(`/logs/reactions/${logId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching reaction log:', error);
    throw error;
  }
};